import { dscvrIcApi } from '@/shared/api';
import type { ReferralCommunityQuery } from 'dfx/edge/edge.did';

export const useReferralCommunityQuery = (params: ReferralCommunityQuery) => {
  return dscvrIcApi.referral.getReferralCommunity(params);
};
